import React from "react";
import { useColours } from "@/contexts/ColoursContext";
import { imageUrl } from "@/lib/api";

/**
 * Filter chips for Colour. value === "all" | one of the colour names.
 * Renders nothing if no colours are defined yet. The dot/thumb shows
 * the swatch_image when present, otherwise a flat hex swatch dot.
 */
const ColourChips = ({ value, onChange, testidPrefix = "col" }) => {
  const { colours } = useColours();
  if (!colours.length) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid={`${testidPrefix}-chips`}>
      {colours.map((c) => {
        const active = value === c.name;
        return (
          <button
            key={c.name}
            data-testid={`${testidPrefix}-${c.name}`}
            onClick={() => onChange(active ? "all" : c.name)}
            type="button"
            aria-pressed={active}
            className={`nb-btn px-3 py-1.5 text-sm transition-all flex items-center gap-1.5 ${
              active ? "nb-btn-dark" : "bg-white"
            }`}
          >
            {c.swatch_image ? (
              <img
                src={imageUrl(c.swatch_image)}
                alt=""
                className="inline-block w-4 h-4 rounded-full border border-black/40 object-cover"
              />
            ) : c.swatch ? (
              <span
                className="inline-block w-3 h-3 rounded-full border border-black/40"
                style={{ background: c.swatch }}
              />
            ) : null}
            {c.name}
          </button>
        );
      })}
    </div>
  );
};

export default ColourChips;

export const ColourBadge = ({ name, swatch, swatchImage }) => {
  if (!name) return null;
  return (
    <span
      data-testid={`colour-badge-${name}`}
      className="inline-flex items-center gap-1 text-[10px] font-bold tracking-wide px-2 py-0.5 rounded-full border border-black/30 bg-white"
    >
      {swatchImage ? (
        <img
          src={imageUrl(swatchImage)}
          alt=""
          className="inline-block w-3 h-3 rounded-full border border-black/40 object-cover"
        />
      ) : swatch ? (
        <span
          className="inline-block w-2.5 h-2.5 rounded-full border border-black/40"
          style={{ background: swatch }}
        />
      ) : null}
      {name}
    </span>
  );
};
